import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import swal from "sweetalert";
import useSWR from "swr";
import useAuth from "../../../../initialpage/hooks/useAuth";
import NotFoundPage from "../../StoreComponents/NotFoundPage";
import { API } from "../../StoreComponents/conflict";
import useGetData from "../../StoreComponents/hooks/useGetData";
import { PostStoreLog } from "../../StoreComponents/hooks/useStoreLog";
import Cookies from "js-cookie"

import "./NewRequisition.css";
const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const NewRequisition = () => {
  const [quantityCount, setQuantityCount] = useState(0);
  const QuantityChangeCount = (e) => {
    setQuantityCount(parseInt(e.target.value));
  };
  const QuantityChangeCountByPlus = () => {
    setQuantityCount(quantityCount + 1);
  };
  const QuantityChangeCountByMinus = () => {
    setQuantityCount(quantityCount - 1);
  };

  // console.log(quantityCount);
  const empID = parseInt(Cookies.get("E_Id"));
  const user = JSON.parse(Cookies.get("user") || '{}');
  const navigate = useNavigate();
  const { CountData } = useGetData();
  const { mutate } = CountData();
  console.log(user);
  const [openElement, setOpenElement] = useState(false);
  const [productObject, setProductObject] = useState({});
  const [productArray, setProductArray] = useState([]);
  const [showupdateBtn, setShowupdateBtn] = useState([]);
  const [updatedQty, setUpdateQty] = useState(null);

  const { data: stockProduct, error: error1 } = useSWR(
    empID
      ? `store/products/storeProductsFR/${empID
      }?page=${0}&limit=${10000}`
      : null,
    fetcher1
  );
  const { data: checkPending, error: error2 } = useSWR(
    `store/requisition/check_pending/byId`,
    fetcher
  );
  console.log(checkPending);
  // set Product category select list
  let stockProductOption = [];
  if (stockProduct && stockProduct.length > 0) {
    stockProductOption = stockProduct.map((data) => {
      let optionsItem = {};
      optionsItem.value = `${data.PROID}-${data.UNIT}-${data.PRODUNIT}-${data.PROQTY}`;
      optionsItem.label = `${data.PRONAME} - ${data.PRONAMETWO}`;
      return optionsItem;
    });
  }
  // console.log(stockProduct)
  const handleProduct = (product) => {
    setProductObject(product);
    // console.log(product);
    if (!openElement) {
      setOpenElement(true);
    }
  };

  // react hook form
  const { register, handleSubmit, reset } = useForm();

  let count = 1;
  const onSubmit = (data) => {
    const split = productObject.value.split("-");
    data.QUANTITY = quantityCount;
    console.log(parseInt(split[3]), parseInt(data.QUANTITY));

    if (parseInt(data.QUANTITY) > parseInt(split[3])) {
      swal({
        title: "Opps !",
        text: "This Product quantity is shorter then your requirement",
        icon: "warning",
        button: "Ok",
      });
    } else {
      console.log("object");
      const found = productArray.find(
        (item) => item.proid === parseInt(split[0])
      );
      if (found) {
        swal({
          title: "OOPS !",
          text: "Product already in cart",
          icon: "warning",
          button: "Ok",
        });
      } else {
        const product = {
          proid: parseInt(split[0]),
          productName: productObject.label,
          unit: split,
          prorequqty: parseInt(data.QUANTITY),
          remarks: data.REMARKS,
        };
        //   console.log(product);
        setProductArray([...productArray, product]);
        reset();
        setQuantityCount(0);
      }
    }
  };
  console.log(productArray);

  const deleteProduct = (id) => {
    const proceed = window.confirm("Are you sure?");
    if (proceed) {
      const remaining = productArray.filter((product) => product.proid !== id);
      setProductArray(remaining);
    }
  };

  const [buttonLoading, setButtonLoading] = useState(false);

  const handleRequest = () => {
    swal({
      title: "Are you sure?",
      //  text: "Once deleted, you will not be able to recover this imaginary file!",
      buttons: true,
      //  dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setButtonLoading(true);
        if (productArray.length > 0) {
          // console.log(productArray);
          const array = productArray.map((product) => {
            const obj = {
              proid: product.proid,
              prorequqty: product.prorequqty,
              remarks: product.remarks,
            };
            return obj;
          });
          //console.log({ user_id: parseInt(user?.employe_id), products: array });

          API.post("store/requisition", {
            user_id: parseInt(empID),
            products: array,
          }).then((res) => {
            console.log(res);
            if (!res.data.error) {
              swal({
                title: "Thank You !",
                text: "Successfully Added",
                icon: "success",
                button: "Ok",
              });
              PostStoreLog(1, "new requisition");
              setButtonLoading(false);
              setProductArray([]);

              mutate();
              navigate("/requisition/view");
            }
          });
        } else {
          alert("Sorry, You dont have any data!");
        }
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  // handle change Quantity Amount
  const changeQuantityAmount = (id, e) => {
    setShowupdateBtn([...showupdateBtn, "true", id]);
    const quantity = parseInt(e.target.value);
    setUpdateQty(quantity);
  };

  // update temporary state
  const updateProduct = (id) => {
    const fil = productArray.map((item) => {
      let myItem = item;
      if (item.proid === parseInt(id)) {
        myItem.prorequqty = updatedQty;
      }
      return myItem;
    });
    // console.log(fil)

    setShowupdateBtn([]);
    swal({
      title: "Thank You !",
      text: "Successfully Updated",
      icon: "success",
      button: "Ok",
    });
  };

  // console.log(productArray);
  //console.log(checkPending)

  return (
    <>
      <Helmet>
        <title>New Requisition - BBA STORE</title>
        <meta name="description" content="New Requisition - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>

      <div className="page-wrapper">
        {!checkPending ? (
          <NotFoundPage />
        ) : (
          <>
            {checkPending.STATUS === "Pending" ? (
              <div
                className="mt-5 border p-3 mx-3"
                style={{
                  borderRadius: "10px",
                  borderColor: "rgb(110, 110, 240)",
                }}
              >
                <h1 className="text-center">Your requisition is approved</h1>
                <h3 className="text-center">
                  Please collect the approval product
                </h3>
                <h4 className="text-center">Thank You &#128515;</h4>
              </div>
            ) : (
              <div className="content container-fluid main-container">
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <h3 className="text-start text-dark">
                    Make Request For Product Requisitions
                  </h3>
                </div>

                <div
                  style={{ background: "white", borderRadius: "10px" }}
                  className="p-3"
                >
                  <div className="add_category py-5">
                    <div className="row">
                      <div className="col-12">
                        <label htmlFor="Product_Name">
                          Product Name <span className="color-red">*</span>
                        </label>
                        <Select
                          onChange={handleProduct}
                          style={{ borderRadius: "10px" }}
                          className="text-start fs-6"
                          options={stockProductOption}
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      openElement
                        ? "category show mb-3 table-container p-2"
                        : "category my-4 table-container p-2"
                    }
                    style={{ background: "white", borderRadius: "10px" }}
                  >
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="row mt-3">
                        <div className="col-12 col-md-4 col-lg-4">
                          <label htmlFor="Quantity">
                            Quantity <span className="color-red">*</span>
                          </label>
                          <div className="pass-wrapper d-flex input-group mb-3">
                            <input
                              // {...register("QUANTITY")}
                              value={quantityCount}
                              onChange={QuantityChangeCount}
                              type="number"
                              min="1"
                              placeholder="Enter Quantity"
                              className=" form-control "
                              required
                            />
                            <div>
                              <span
                                class="input-group-text btn-eye p-0 pt-1 px-1 rounded-0 bg-light"
                                role="button"
                                tabindex="0"
                                id="basic-addon2"
                                onClick={QuantityChangeCountByPlus}
                              >
                                <i
                                  class="fa-solid fa-angle-up"
                                  aria-hidden="true"
                                ></i>
                              </span>
                              <span
                                class="input-group-text btn-eye p-0 pb-1 px-1 rounded-0 bg-light"
                                role="button"
                                tabindex="0"
                                id="basic-addon2"
                                onClick={QuantityChangeCountByMinus}
                              >
                                <i
                                  class="fa-solid fa-angle-down"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8">
                          <label htmlFor="remarks">Remarks</label>
                          <textarea
                            {...register("REMARKS")}
                            placeholder="Enter Remarks"
                            className="input-field-new p-2"
                            cols="30"
                            rows="3"
                          ></textarea>
                        </div>
                      </div>
                      <div className="mx-auto">
                        <button
                          type="submit"
                          className="mt-5 px-4 btn btn-color_store"
                        >
                          <i className="fa fa-plus"></i>
                          <span> Add</span>
                        </button>
                      </div>
                    </form>
                    <div className="row mt-5 ">
                      <div className="col-12">
                        <div id="printArea" className="table-responsive-sm">
                          <table className="table table-bordered table-striped">
                            <thead>
                              <tr className="tableColor">
                                <th>S/N</th>
                                <th>Product Name</th>
                                <th>Quantity</th>
                                <th>Unit</th>
                                <th>Remarks</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {productArray.map((product) => {
                                const {
                                  proid,
                                  productName,
                                  prorequqty,
                                  remarks,
                                  unit,
                                } = product;
                                const unit1 = unit[1];
                                return (
                                  <tr key={count}>
                                    <th>{count++}</th>
                                    <td>{productName}</td>

                                    <td>
                                      <input
                                        type="number"
                                        onChange={(e) =>
                                          changeQuantityAmount(proid, e)
                                        }
                                        defaultValue={prorequqty}
                                        style={{
                                          width: "60px",
                                          paddingLeft: "5px",
                                        }}
                                        className="input-field-new"
                                      />
                                    </td>
                                    <td>{unit1}</td>
                                    <td>{remarks}</td>
                                    <td>
                                      <button
                                        onClick={() => deleteProduct(proid)}
                                        data-bs-toggle="tooltip"
                                        title="Delete"
                                        type="button"
                                        className="btn btn-red_store px-3"
                                      >
                                        <i className="fa fa-times fs-6"></i>
                                      </button>
                                      {showupdateBtn[0] === "true" &&
                                        showupdateBtn[1] === proid ? (
                                        <button
                                          onClick={() => updateProduct(proid)}
                                          data-bs-toggle="tooltip"
                                          title="update"
                                          type="button"
                                          className="btn btn-outline-color_store bg-primary text-white px-3 ms-3"
                                        >
                                          <i className="fa fa-check fs-6"></i>
                                        </button>
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                          {!buttonLoading ? (
                            <button
                              onClick={handleRequest}
                              className="btn btn-color_store px-3 mt-3"
                            >
                              {" "}
                              <i className="fa fa-send-o" />{" "}
                              <span>Send Request</span>
                            </button>
                          ) : (
                            <button className="btn btn-color_store px-3 mt-3">
                              {" "}
                              <i className="fa fa-send-o" />{" "}
                              <span>Send Request</span>
                              <div
                                style={{ width: "20px", height: "20px" }}
                                class="spinner-border ms-2  text-light"
                                role="status"
                              >
                                <span style={{}} class="visually-hidden ">
                                  Loading...
                                </span>
                              </div>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default NewRequisition;
